import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IPost } from "../../types/backend";
import { callFetchPost } from "../../config/api";

interface IState {
  isFetching: boolean;
  meta: {
    current: any;
    pageSize: any;
    pages: any;
    total: any;
  };
  result: IPost[];
}

// first, create thunk
export const fetchPost = createAsyncThunk(
  "post/fetchPost",
  async ({ query }: { query: string }) => {
    const response = await callFetchPost(query);
    return response;
  }
);

const initialState: IState = {
  isFetching: true,
  meta: {
    current: 1,
    pageSize: 10,
    pages: 0,
    total: 0,
  },
  result: [],
};

export const postSlice = createSlice({
  name: "post",
  initialState,
  reducers: {
    setActiveMenu: (state, action) => {},
  },

  extraReducers: (builder) => {
    builder.addCase(fetchPost.pending, (state, action) => {
      state.isFetching = true;
    });
    builder.addCase(fetchPost.rejected, (state, action) => {
      state.isFetching = false;
    });
    builder.addCase(fetchPost.fulfilled, (state, action: any) => {
      if (action.payload && action.payload.data) {
        state.isFetching = false;
        state.meta = action.payload.data.meta;
        state.result = action.payload.data.result;
      }
    });
  },
});

export const { setActiveMenu } = postSlice.actions;

export default postSlice.reducer;
